import {
  ZodClientWithUsers,
  ZodUserWithSubscription,
} from '@rotra-air-ocean/rotranext-shared-code';

export const isPendingUser = (userWithSubscription: ZodUserWithSubscription) =>
  !userWithSubscription.firstname || !userWithSubscription.lastname;

export const isActiveUser = (userWithSubscription: ZodUserWithSubscription) =>
  (userWithSubscription.firstname && userWithSubscription.lastname) !==
  undefined;

export const hasAdminUser = (client: ZodClientWithUsers) =>
  client.users.some((user) => user.subscription.role === 'admin');

export const getPendingUsers = (client: ZodClientWithUsers) =>
  client.users.filter((x) => isPendingUser(x));

export const getActiveUsers = (client: ZodClientWithUsers) =>
  client.users.filter((x) => isActiveUser(x));

export const hasDisplayName = (client?: ZodClientWithUsers) =>
  typeof client?.custom_client_fields?.display_name === 'string' &&
  isValidDisplayBame(client.custom_client_fields?.display_name.trim());

export const isValidDisplayBame = (name: string) =>
  name === '' || name.trim().length > 0;

export const getClientName = (
  clients: ZodClientWithUsers[],
  clientId: string
): string => {
  const client = clients.find((c) => c.id === clientId);
  if (!client) {
    return '';
  }

  return hasDisplayName(client)
    ? client.custom_client_fields?.display_name || ''
    : client.client_name || '';
};
